import React from "react";

const SearchBox = ({searchChange}) => {
    return (
        <div className="pa2 ">
            <input 
            className="pa3 ba b--purple bg-light-purple br2 b "
            type='search' 
            placeholder="Search kitties" 
            onChange={searchChange}
            />
        </div>
    );
}

export default SearchBox;